import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Ongoing Affect · Elevate Your Brand</p>
        <h1>Transform Your Brand's Presence.</h1>
        <p className="lede">
          At Ongoing Affect, we specialize in brand development and innovative digital advertising strategies that resonate with your audience. Let us help you create a lasting impact.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Services
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Strategic Brand Development</h2>
          <p>
            We craft unique brand identities that stand out in the marketplace and connect with your target audience.
          </p>
        </article>
        <article>
          <h2>Digital Advertising Expertise</h2>
          <p>
            Our tailored digital advertising strategies ensure your brand reaches the right people at the right time.
          </p>
        </article>
        <article>
          <h2>Data-Driven Insights</h2>
          <p>
            Leverage analytics to refine your marketing efforts and maximize your return on investment with our expert guidance.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;